export default "__VITE_ASSET__m$gQOX34__"